export default __webpack_public_path__ + "static/media/replit-logo-vector 1.6a76dd4a.svg";